import React, { useState } from 'react';
import { Copy, Mail } from 'lucide-react';

export default function ForwardingAddressCard({ address, colors }) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    if (!address) return;
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (err) {
      // Clipboard permission denied (browser policy) — non-fatal
      console.error('Copy to clipboard failed:', err);
    }
  };

  return (
    <div className="rounded-xl border p-5 space-y-3"
      style={{ backgroundColor: colors.surface, borderColor: colors.border }}
      data-testid="forwarding-address-card">
      <div className="flex items-center gap-2 text-xs uppercase font-semibold tracking-wider"
        style={{ color: colors.textMuted }}>
        <Mail size={14} /> Your forwarding address
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <code className="flex-1 min-w-[240px] px-3 py-2 rounded-lg text-sm font-mono break-all"
          style={{ backgroundColor: colors.bg, color: colors.text, border: `1px solid ${colors.border}` }}
          data-testid="forwarding-address-value">
          {address || '—'}
        </code>
        <button data-testid="copy-address-btn" onClick={onCopy}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold text-white"
          style={{ backgroundColor: colors.accent }}>
          <Copy size={14} /> {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <p className="text-xs" style={{ color: colors.textMuted }}>
        Forward receipt emails here — Postmark delivers them and Clasifi auto-extracts each into a pending review row.
      </p>
    </div>
  );
}
